/* =============================================================
   Wellubia storefront configuration

   Single place to connect the site to a commerce backend.
   Nothing else in the codebase should hard-code a shop domain.

   MODE
     'local', the bag and /cart.html run entirely on this site.
                 No request leaves the domain. This is the default so
                 the site can be developed and demoed standalone.
     'shopify', checkout hands off to Shopify using a cart permalink
                 built from the variant ids below.

   TO CONNECT SHOPIFY
     1. set MODE to 'shopify'
     2. set DOMAIN to the storefront domain
     3. confirm VARIANTS matches the live catalogue
        (Shopify → Products → variant id, or /products.json)
   ============================================================= */
window.WELLUBIA_SHOP = {
  MODE: 'shopify',
  DOMAIN: 'https://www.wellubia.com',
  CURRENCY: '₹',
  FREE_SHIPPING: 0,

  /* What delivery would cost the customer if Wellubia did not absorb it.
     Shown beside the pack saving so the two read as one figure. Keep this in
     step with DELIVERY_SAVING in scripts/build_shopify_theme.py, which writes
     the same number into the bag. */
  DELIVERY_SAVING: 120,

  /* handle → Shopify variant id. Pulled from products.json. */
  VARIANTS: {
    'wellubia-gift-hamper': '42753130823875',
    '1-sadabahaar-paan-gift-box': '42753129513155',
    'supreme-5-in-1': '42753126826179',
    'rose-mintiz': '42753126301891',
    'playful-minty-fennel': '42753124565187',
    'jammu-mix': '42753119289539',
    'in-flight-freshener': '42753117946051',
    'fennel-minitz': '42753111752899',
    'evergreen-mix': '42753110311107',
    'cardamom-fennel': '42753109557443',
    'omega-mix': '42753107132611',
    'nutri-seeds': '42753106673859',
    'flax-seed-mukhwas': '42753106280643',
    'crunchy-coriander-splitz': '42753105821891',
    'sadabahar-pan': '42753103986883',
    'tamarind-candies': '42753073807555',
    'mocktail-shots': '42753070006467',
    'mango-fun': '42753068695747',
    'cumin-nibbles': '42751697223875',
    'anaardana-shots': '42751697125571',
    'benaras-meetha': '54102386737347',
    'kathiawadi-khatta': '54102386770115',
    'nawab-e-lucknow': '54102386802883',
    'kolkata-mishti': '54102386835651',
    'the-heritage-collection': '54102386868419'
  },

  /* A ready combination is one line in the cart but several bottles in the
     box. Everything that enforces the two-bottle minimum has to know that,
     or a perfectly good combo gets refused for being "one product".
     Generated from READY_PACKS in scripts/build_shopify_theme.py; the build
     fails if the two ever disagree. */
  BUNDLE_BOTTLES: {
    'do-paan-ek-jaan': 2,
    'rab-ne-bana-di-jodi': 2,
    'khatta-meetha': 2,
    'imli-met-saunf': 2,
    'picture-abhi-baaki-hai': 3,
    'no-sugarcoating': 3,
    'khaas-mukhwas': 3,
    'safar-ke-saathi': 3,
    'mehfil-mein-chaar-chaand': 4,
    'teen-se-bhale-chaar': 4
  },

  /* The Mehfil Potli rides along with a pack. It is not a bottle and must
     never count towards the minimum. */
  ADDON_HANDLES: ['wellubia-gift-hamper'],

  /* How many bottles a cart line is worth. */
  bottlesIn: function (handle, qty) {
    qty = qty || 0;
    if (this.ADDON_HANDLES.indexOf(handle) !== -1) return 0;
    var inside = this.BUNDLE_BOTTLES[handle];
    return (inside || 1) * qty;
  },

  /* Bottles across a whole bag, in the shape both drawers keep it. */
  bottleCount: function (lines) {
    var self = this;
    return (lines || []).reduce(function (n, line) {
      return n + self.bottlesIn(line.handle, line.qty || line.quantity || 0);
    }, 0);
  },

  /* The live pack offer, as the cart applies it: 2 bottles save 15%,
     3 or more save 20%, and 25% once the full-price total reaches Rs 1,400.
     Same rule as the Liquid cart in scripts/build_shopify_theme.py; keep the
     two in step. `mrp` is in rupees. Returns a whole-number percentage. */
  packRate: function (bottles, mrp) {
    if (bottles < 2) return 0;
    if (mrp >= 1400) return 25;
    return bottles >= 3 ? 20 : 15;
  },

  /* Where the bag's primary button should go.
     `base` is '' at the site root, '../' one level deep. */
  checkoutHref: function (bag, base) {
    base = base || '';
    if (this.MODE === 'shopify') {
      var lines = (bag || [])
        .map(function (i) { return (i.vid || this.VARIANTS[i.handle]) + ':' + i.qty; }, this)
        .filter(function (l) { return l.indexOf('undefined') === -1; });
      if (lines.length) return this.DOMAIN + '/cart/' + lines.join(',');
      return this.DOMAIN + '/collections/all';
    }
    return base + '/cart';
  },

  /* Single bottles are not sold. Product CTAs open the custom pack builder. */
  buyNowHref: function (handle, qty, base) {
    base = base || '';
    var vid = this.VARIANTS[handle];
    if (this.MODE === 'shopify' && vid) {
      return this.DOMAIN + '/products/' + handle;
    }
    return base + '/pages/cart?buy=' + encodeURIComponent(handle) + '&qty=' + (qty || 1);
  },

  /* ---------------------------------------------------------------------
     Merchandising. All of it lives here so nothing is hard-coded in a page.
     --------------------------------------------------------------------- */

  /* Small-batch dates. Honest urgency: say when it was made and when the
     next one lands. Update these when a batch actually changes. */
  BATCH: { made: '12 March', next: 'mid-April' },

  /* Custom pack savings. Shopify discount codes enforce the live offer. */
  BUNDLES: [
    { qty: 2, off: 0.15, label: 'Pick 2' },
    { qty: 3, off: 0.20, label: 'Pick 3 or 4' }
  ],

  /* WhatsApp. The click-to-chat link works with no backend at all.
     Order and abandoned-cart automation needs the Business API - see
     CONNECT.md for which piece goes where. */
  WHATSAPP: { number: '919958895663', enabled: true },

  /* Where captured leads should go. Empty means the form falls back to
     opening a pre-addressed email, which is what it does today. */
  LEAD_ENDPOINT: '',

  /* How many units of a bundle tier the basket currently qualifies for. */
  bundleFor: function (units) {
    var best = null;
    (this.BUNDLES || []).forEach(function (b) {
      if (units >= b.qty && (!best || b.qty > best.qty)) best = b;
    });
    return best;
  },

  /* Rupees saved at the current basket size, and what the next tier needs. */
  bundleState: function (units, subtotal) {
    var hit = this.bundleFor(units);
    var next = null;
    (this.BUNDLES || []).forEach(function (b) {
      if (units < b.qty && (!next || b.qty < next.qty)) next = b;
    });
    return {
      tier: hit,
      saved: hit ? Math.round(subtotal * hit.off) : 0,
      next: next,
      needs: next ? next.qty - units : 0
    };
  },

  waHref: function (text) {
    if (!this.WHATSAPP || !this.WHATSAPP.enabled) return null;
    return 'https://wa.me/' + this.WHATSAPP.number +
           (text ? '?text=' + encodeURIComponent(text) : '');
  },

  external: function () { return this.MODE === 'shopify'; }
};
